import { render, staticRenderFns } from "./workspace-setting-overview.vue?vue&type=template&id=7735357e&"
import script from "./workspace-setting-overview.vue?vue&type=script&lang=js&"
export * from "./workspace-setting-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports